import React from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import pro1p1 from "../../../images/project1-p1.png";
import pro1p2 from "../../../images/project1-p2.png";
import pro1p3 from "../../../images/project1-p3.png";

const Project01 = () => {
  return (
    <Container className="font mt-5">
      <h1 className="text-center  ">
        AlGO <span className="heading"> DIGITAL</span>
      </h1>
      <Container className=" mt-5 p-5 project-bg project-container border border-4 border-info rounded  ">
        <Row>
          <Col sm={12} md={6} lg={6}>
            <h2 className="fw-bold text-center mb-2">Description</h2>
            <h5 className="text-secondary">
              Algo Digital is a digital service selling website where a user can
              buy digital services like web design, SEO, content writing and
              social media marketing.
            </h5>

            <li>
              Users and Admin can sign up and log in to this website using
              google or Email and password. Protected Route is developed by
              React Router v6.
            </li>
            <li>
              Users can book a service, see his orders, and give a review. Admin
              can see all orders of users.
            </li>
            <li>
              Admin can add a new service and manage all the features of the
              website. Both admin and user can use dashboard facility.
            </li>
            <h5 className="mt-2">
              Frontend:
              <span>
                <span className="badge bg-info m-1">HTML 5</span>
                <span className="badge bg-info">CSS3</span>
                <span className="badge bg-info m-1 ">Bootstrap</span>
                <span className="badge bg-info">React.js</span>
                <span className="badge bg-info m-1">JavaScript(ES6)</span>
                <span className="badge bg-info m-1">React Router v6</span>
              </span>
            </h5>
            <h5 className="mt-2">
              Backend:
              <span>
                <span className="badge bg-info m-1">MongoDB</span>
                <span className="badge bg-info">Express.js</span>
              </span>
            </h5>

            <h5>
              Link:
              <span>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://algo-digital.web.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Live
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/algo-digital-client-side"
                  target="_blank"
                  rel="noreferrer"
                >
                  Client Side
                </a>
                <a
                  className="link-btn badge bg-info m-1"
                  href="https://github.com/moshiur01/algo-digital-server-side"
                  target="_blank"
                  rel="noreferrer"
                >
                  Server Side
                </a>
              </span>
            </h5>
          </Col>
          <Col sm={12} md={6} lg={6} className="my-auto">
            <Carousel className=" carousel-img  border rounded  border-3 border-info ">
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid "
                  src={pro1p1}
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro1p2}
                  alt="Second slide"
                />
              </Carousel.Item>
              <Carousel.Item interval={1000}>
                <img
                  className="d-block w-100 img-fluid"
                  src={pro1p3}
                  alt="Third slide"
                />
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Project01;
